import Vue from "vue";
import {
  ArticlesService,
  CommentsService,
  FavoriteService
} from "@/common/api.service";
import { COMPANY_ID } from "@/common/config.js";

import {
  FETCH_ARTICLE,
  FETCH_COMMENTS,
  COMMENT_CREATE,
  COMMENT_DESTROY,
  FAVORITE_ADD,
  FAVORITE_REMOVE,
  ARTICLE_PUBLISH,
  ARTICLE_EDIT,
  ARTICLE_EDIT_ADD_TAG,
  ARTICLE_EDIT_REMOVE_TAG,
  ARTICLE_DELETE,
  ARTICLE_RESET_STATE,
  REGISTER_SET_FORM,
  REGISTER_RESET_FORM,
  REGISTER_SET_ADDRESS,
  ADDRESS_ZIPCODE,
  SET_ERROR_MESSAGE,
  SET_TOKEN
} from "./actions.type";
import {
  RESET_STATE,
  SET_ARTICLE,
  SET_COMMENTS,
  TAG_ADD,
  TAG_REMOVE,
  UPDATE_ARTICLE_IN_LIST,
  SET_REGISTER_FORM,
  RESET_REGISTER_FORM,
  SET_ADDRESS_REGISTER,
  SET_ADDRESS_ZIPCODE,
  SET_ERROR,
  SET_REGISTER_TOKEN
} from "./mutations.type";

const initialState = {
  form: {
    company_id: COMPANY_ID,
    first_name: null,
    family_name: null,
    first_name_kana: null,
    family_name_kana: null,
    phone_number: null,
    zip_code: null,
    address_first: null,
    address_second: null,
    address_third: null,
    department: null,
    // email: null,
    // email_confirm: null,
    // password: null,
    // password_confirmation: null,
    addresses: [
      {
        first_name: null,
        family_name: null,
        first_name_kana: null,
        family_name_kana: null,
        phone_number: null,
        email: null,
        zip_code: null,
        prefecture_id: null,
        address_first: null,
        address_second: null,
        address_third: null,
        company_name: null,
        department: null,
        company_url: null
      }
    ],
    is_address_other: false
  },
  temp: {
    zipcode: null,
    address1: null,
    address2: null,
    address3: null,
    delivery_zipcode: null,
    delivery_address1: null,
    delivery_address2: null,
    delivery_address3: null
  },
  comments: [],
  token: null
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_ARTICLE](context, articleSlug, prevArticle) {
    // avoid extronuous network call if article exists
    if (prevArticle !== undefined) {
      return context.commit(SET_ARTICLE, prevArticle);
    }
    const { data } = await ArticlesService.get(articleSlug);
    context.commit(SET_ARTICLE, data.article);
    return data;
  },
  async [FETCH_COMMENTS](context, articleSlug) {
    const { data } = await CommentsService.get(articleSlug);
    context.commit(SET_COMMENTS, data.comments);
    return data.comments;
  },
  async [COMMENT_CREATE](context, payload) {
    await CommentsService.post(payload.slug, payload.comment);
    context.dispatch(FETCH_COMMENTS, payload.slug);
  },
  async [COMMENT_DESTROY](context, payload) {
    await CommentsService.destroy(payload.slug, payload.commentId);
    context.dispatch(FETCH_COMMENTS, payload.slug);
  },
  async [FAVORITE_ADD](context, slug) {
    const { data } = await FavoriteService.add(slug);
    context.commit(UPDATE_ARTICLE_IN_LIST, data.article, { root: true });
    context.commit(SET_ARTICLE, data.article);
  },
  async [FAVORITE_REMOVE](context, slug) {
    const { data } = await FavoriteService.remove(slug);
    // Update list as well. This allows us to favorite an article in the Home view.
    context.commit(UPDATE_ARTICLE_IN_LIST, data.article, { root: true });
    context.commit(SET_ARTICLE, data.article);
  },
  [ARTICLE_PUBLISH]({ state }) {
    return ArticlesService.create(state.article);
  },
  [ARTICLE_DELETE](context, slug) {
    return ArticlesService.destroy(slug);
  },
  [ARTICLE_EDIT]({ state }) {
    return ArticlesService.update(state.article.slug, state.article);
  },
  [ARTICLE_EDIT_ADD_TAG](context, tag) {
    context.commit(TAG_ADD, tag);
  },
  [ARTICLE_EDIT_REMOVE_TAG](context, tag) {
    context.commit(TAG_REMOVE, tag);
  },
  [ARTICLE_RESET_STATE]({ commit }) {
    commit(RESET_STATE);
  },
  [REGISTER_SET_FORM]({ commit }, payload) {
    commit(SET_REGISTER_FORM, payload);
  },
  [SET_TOKEN]({ commit }, payload) {
    commit(SET_REGISTER_TOKEN, payload);
  },
  [REGISTER_RESET_FORM]({ commit }) {
    commit(RESET_REGISTER_FORM);
  },
  [REGISTER_SET_ADDRESS]({ commit }, payload) {
    commit(SET_ADDRESS_REGISTER, payload);
  },
  [ADDRESS_ZIPCODE]({ commit }, payload) {
    commit(SET_ADDRESS_ZIPCODE, payload);
  },
  [SET_ERROR_MESSAGE]({ commit }) {
    commit(SET_ERROR, {});
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_ARTICLE](state, article) {
    state.article = article;
  },
  [SET_COMMENTS](state, comments) {
    state.comments = comments;
  },
  [TAG_ADD](state, tag) {
    state.article.tagList = state.article.tagList.concat([tag]);
  },
  [TAG_REMOVE](state, tag) {
    state.article.tagList = state.article.tagList.filter((t) => t !== tag);
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  },
  [SET_REGISTER_FORM](state, payload) {
    state.form = { ...state.form, ...payload };
  },
  [SET_ADDRESS_REGISTER](state, payload) {
    state.form.addresses[0] = { ...state.form.addresses[0], ...payload };
    state.form = { ...state.form };
  },
  [RESET_REGISTER_FORM](state) {
    state.form = initialState.form;
  },
  [SET_ADDRESS_ZIPCODE](state, payload) {
    state.temp = { ...state.temp, ...payload };
  },
  [SET_REGISTER_TOKEN](state, payload) {
    state.token = payload;
  }
};

const getters = {
  registerForm: (state) => state.form,
  registerToken: (state) => state.token,
  addressZipcode(state) {
    return state.temp;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
